import React from 'react';

// function to formate the word Authenticate®
export const formatText = (text) => {
    const parts = text.split(/(®)/g);
    return parts.map((part, index) =>
        part === '®' ? <sup key={`${part}-${index}`}>®</sup> : part
    );
};
